import { render } from '@testing-library/preact';
import { expect } from 'chai';
import { ButtonLayout } from '../ButtonLayout';
import { ToolbarSeparator } from '#UNSAFE_Toolbar/ToolbarSeparator';
import { BaseButton } from '../../UNSAFE_BaseButton';
import { Button } from '../../UNSAFE_Button';
import { MenuButton } from '../../UNSAFE_MenuButton';
import { SplitMenuButton } from '../../UNSAFE_SplitMenuButton';

describe('Test ButtonLayout component', () => {
  it('Checks for ButtonLayout content', async () => {
    const sampleButtonLayout = (
      <ButtonLayout>
        <BaseButton></BaseButton>
        <Button isDisabled={true}></Button>
        <ToolbarSeparator />
        <MenuButton></MenuButton>
        <SplitMenuButton></SplitMenuButton>
      </ButtonLayout>
    );
    const dom = render(sampleButtonLayout);
    const buttonLayout = dom.container.querySelector('div');
    const content = buttonLayout?.childNodes;

    expect(buttonLayout).not.to.be.null;
    expect(content?.length).equals(5);
  });
  it('Checks for "lg" spacing class', async () => {
    const sampleLgButtonLayout = (
      <ButtonLayout spacing="lg">
        <BaseButton></BaseButton>
        <Button isDisabled={true}></Button>
        <ToolbarSeparator />
        <MenuButton></MenuButton>
        <SplitMenuButton></SplitMenuButton>
      </ButtonLayout>
    );

    const dom = render(sampleLgButtonLayout);
    const buttonLayout = dom.container.querySelector('div');

    // @ts-ignore
    const className = buttonLayout.className;
    const lgClass = 'ButtonLayoutVariants_multiVariantStyles_spacing_lg';
    expect(className).to.be.a('string').that.contains(lgClass);
  });
  it('Checks for "sm" spacing class', async () => {
    const sampleSmButtonLayout = (
      <ButtonLayout spacing="sm">
        <BaseButton></BaseButton>
        <Button isDisabled={true}></Button>
        <ToolbarSeparator />
        <MenuButton></MenuButton>
        <SplitMenuButton></SplitMenuButton>
      </ButtonLayout>
    );

    const dom = render(sampleSmButtonLayout);
    const buttonLayout = dom.container.querySelector('div');

    // @ts-ignore
    const className = buttonLayout.className;
    const smClass = 'ButtonLayoutVariants_multiVariantStyles_spacing_sm';
    expect(className).to.be.a('string').that.contains(smClass);
  });
});
